import type { StateCreator } from 'zustand';

export type AuthSlice = {
  // [PROPS]
  auth_access_token?: string;
  auth_verify_access_token?: string;
  auth_refresh_token?: string;
  auth_expiration_token_date: number;

  // [METHODS]
  auth_set_user_credentials: (
    params: Partial<Omit<AuthSlice, 'auth_set_user_credentials' | 'auth_clear'>>
  ) => void;
  auth_clear: () => void;
};

export const createAuthSlice: StateCreator<AuthSlice, [], [], AuthSlice> = (set) => ({
  // [PROPS]
  auth_access_token: undefined,
  auth_verify_access_token: undefined,
  auth_refresh_token: undefined,
  auth_expiration_token_date: 0,

  // [METHODS]
  auth_set_user_credentials: (args) => set({ ...args }),
  auth_clear: () =>
    set({
      auth_access_token: undefined,
      auth_verify_access_token: undefined,
      auth_refresh_token: undefined,
      auth_expiration_token_date: 0,
    }),
});
